<template>
  
  <v-pagination  v-if="length > 1" :length="length" :model-value="modelValue" @update:model-value="(value) => emit('update:modelValue', value)" 
    :total-visible="totalVisible" class="mt-4" v-slot:item="{ page, isActive, props }">

    <button v-bind="props" :class="{ 'button__pagination--active': isActive, 'button__pagination--inactive': !isActive }">
      {{ page }}
    </button>

  </v-pagination>

</template>



<script setup>

const props = defineProps({
  modelValue: {
    type: Number,
    required: true
  },
  length: {
    type: Number,
    required: true
  },
  totalVisible: {
    type: Number,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);

</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
</style>
